// @ts-nocheck
import React from 'react';
import { Dialog, DialogSuspense, FormattedMessage as T } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const ShippingAccountFormDialogContent = React.lazy(
  () => import('./ShippingAccountFormDialogContent'),
);

function ShippingAccountFormDialog({
  dialogName,
  payload: { shippingAccountId = null, action } = {},
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={
        action === 'edit' ? (
          <T id={'edit_shipping_account'} />
        ) : (
          <T id={'new_shipping_account'} />
        )
      }
      isOpen={isOpen}
      canEscapeKeyClose={true}
      autoFocus={true}
      className={'dialog--shipping-account-form'}
      style={{ width: '1000px', maxWidth: '95vw' }}
    >
      <DialogSuspense>
        <ShippingAccountFormDialogContent
          dialogName={dialogName}
          shippingAccountId={shippingAccountId}
          action={action}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(ShippingAccountFormDialog);